import { type HTMLAttributes, forwardRef } from 'react';

import styles from './PaperCard.module.css';

export type PaperCardProps = HTMLAttributes<HTMLDivElement> & {
  /** 그림자 깊이 — 카드 위계에 따라 선택. 기본값 `md`. */
  depth?: 'sm' | 'md' | 'lg' | 'xl';
  /** 카드 좌상단에 노란 테이프 장식을 표시할지 여부. */
  taped?: boolean;
};

/**
 * 디자인 시스템의 화이트 페이퍼 카드.
 *
 * - 흰 배경 + 잉크 보더 + 어긋난 잉크 그림자.
 * - `taped`를 켜면 좌상단에 노란 크레용 테이프가 살짝 회전된 채로 붙는다 (concept-card 스타일).
 *
 * @see darakcast_kidsday_design_system.html — `.concept-card`, `.comp-block`
 */
export const PaperCard = forwardRef<HTMLDivElement, PaperCardProps>(function PaperCard(
  { depth = 'md', taped = false, className, children, ...rest },
  ref,
) {
  const classes = [
    styles.card,
    styles[`depth-${depth}`],
    taped ? styles.taped : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div ref={ref} className={classes} {...rest}>
      {children}
    </div>
  );
});
